// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"102":"xlsx","133":"pdfmake","182":"canvg"}[chunkId] || chunkId) + "." + {"102":"5a3be129","133":"a5ca3560","182":"c7b95b26","422":"a8f87740"}[chunkId] + ".chunk.js";
};